import Icon from './Icon';
import Span from './Span';
import useTranslation from '../hooks/useTranslation';
import { capitalize } from '../utils';

enum COLOR_CLASS {
  low = 'text-info',
  medium = 'text-warning',
  high = 'text-danger',
  critical = 'text-orange'
};

type PropsIconUrgency = {
  urgency: string;
  icon?: string;
  className?: string;
  fontSize?: string | number;
}

export function IconUrgency(
  {
    urgency,
    icon = 'flag',
    className,
    fontSize,
  }: PropsIconUrgency
) {
  const { t } = useTranslation();
  return (
    <Span
      title={t('Urgency') + ' ' + t(capitalize(urgency))}
      className={className}
    >
      <Icon
        icon={urgency === 'critical' ? 'warning' :icon}
        className={COLOR_CLASS[urgency]}
        fontSize={fontSize}
        data-urgence={urgency}
      />
    </Span>
  );
}

export default IconUrgency;
